module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921114149_T.95fac18a.jpg";